import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseDailyUserReviewProblems } from '@/api/responses/dailyUserReviewProblems'

export namespace DailyUserReviewProblemsApi {
  /**
   * 今日やる問題取得
   *
   * @param subjectCode 教科コード
   * @returns 今日やる問題一覧
   */
  export async function getDailyUserReviewProblems(
    subjectCode: string
  ): Promise<ApiResponseDailyUserReviewProblems | null> {
    return await ApiBase.getWithAccepted(`dailyUserReviewProblems/${subjectCode}`)
  }
}
